import React from "react";
import { useSelector } from "react-redux";
import { selectJobDetailsSection, selectGeneralStation } from "../../../redux/selectors";

const PrintDropPipes = () => {
  const dropPipeDetails = useSelector((state) =>
    selectJobDetailsSection(state, "dropPipes")
  );
  const dropPipeComments = useSelector((state) =>
    selectJobDetailsSection(state, "dropPipeComments")
  );
  const generalSpecsDetails = useSelector(selectGeneralStation);
  const activetab = useSelector((state) => state.activeMechanicalTab.selectedZone);

  const hasDropPipes = dropPipeDetails?.some(detail => detail.HasDropPipes);

  if (!hasDropPipes) {
    return null;
  }

  const stationColor = generalSpecsDetails.find((detail) => detail.Zone === activetab)?.Color || "";

  const isZoneEmpty = (detail) => {
    return (
      !detail.DropPipeID &&
      !detail.InletSize &&
      !detail.DischargeSize &&
      !detail.PaintColor &&
      !detail.Details
    );
  };

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    const groupedDetails = details.reduce((acc, detail) => {
      if (!acc[detail.Zone]) {
        acc[detail.Zone] = [];
      }
      acc[detail.Zone].push(detail);
      return acc;
    }, {});

    return (
      <div>
        {Object.keys(groupedDetails).map((zone, index) => {
          const zoneDetails = groupedDetails[zone];
          const comments = dropPipeComments.find(comment => comment.Zone === zone)?.Comments;

          return (
            <div className="section" key={index}>
              <h3 className="print-zone-label">Zone: {zone}</h3>
              <table className="table table-bordered full-width">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Inlet Size</th>
                    <th>Discharge Size</th>
                    <th>Paint Color</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {zoneDetails.map((detail, idx) => {
                    if (isZoneEmpty(detail)) {
                      return null;
                    }
                    return (
                      <tr key={idx}>
                        <td>{detail.DropPipeID}</td>
                        <td>{detail.InletSize}</td>
                        <td>{detail.DischargeSize}</td>
                        <td>
                          {detail.PaintColor === "Same as Station" ? `Same as Station (${stationColor})` : detail.PaintColor}
                        </td>
                        <td>{detail.Details}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <p><strong>Comments:</strong><br />{comments}</p>
              <br className="clearfix" />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      <h2 className="print-section-header">Drop Pipes Summary</h2>
      {renderDetails(dropPipeDetails)}
    </div>
  );
};

export default PrintDropPipes;
